export default __webpack_public_path__ + "static/media/piece-move-sound-high-19secs-long2.90752293.mp3";